<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="6"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <p class="ys_bk">Banner封面 (建议尺寸：750*680)</p>
                <div class="banner">
                    <img :src="bannerImg"></img>

                    <el-upload 
                    v-if="imgArry.length<1"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :action="addressOss" 
                    :data="dataOss"
                    :before-upload="upload"
                    :on-success="uploadSuccess" 
                    :on-error="uploadError"
                    :on-change="handleChange">
                        <el-button class="bn_btn" type="primary">上传/更新</el-button>
                    </el-upload>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_BASE } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            imageName: '',
            imgArry: [],
            addressOss: API_BASE + '/system/uploadBanner',
            bannerImg: '',
            dataOss: {},
            headers: {
                'Content-Type': 'application/json',
                'token': ''
            }
        }
    },
    created() {
        this.headers.token = localStorage.getItem("token")
        this.getListData()
    },
    methods: {
        getListData() {
            let url = API_BASE + '/client/index'
            let params = {}
            util.getData(url, params, (res) => {
                this.bannerImg = res.data.data
            })
        },
        handleChange(file, fileLists) {
            console.log(URL.createObjectURL(file.raw));
		},

        async upload(file) {    // 上传图片
            let isJPG = file.type === 'image/jpeg';
            let isPNG = file.type === 'image/png';
            let isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG && !isPNG) {
                this.$message.error('请上传 JPG 或者 PNG 格式图片!');
                return
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
                return
            }
            this.imageName = new Date().getTime().toString()
        },
        uploadSuccess(res, file) {// 上传成功
            this.$message.success('图片上传成功！');
            this.getListData()
        },
        uploadError(file){  // 上传失败
            this.$message.error('图片上传失败！');
        },
    }
}
</script>
  
<style lang="less">
.ys_bk{
    font-size: 16px;
    margin-bottom: 20px;
    font-weight: 700;
}
.banner{
    background-color: #fff;
    padding: 40px 20px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img{
        width: 400px;
        height: 350px;
        background-color: #f4f6f8;
    }
    .bn_btn{
        margin: 20px 0;
    }
}

.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/glyBanner/index.vue